import OpenBox from './OpenBox';

export default OpenBox;
